import ReactDOM from "react-dom/client";
import App from "./app";
import React from "react";
import "./index.css";
// import "./sentry";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
